'use client';

import {
  Icon,
  Sheet,
  SheetContent,
  SheetTrigger,
} from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useState } from 'react';

import { images } from '~/landing/assets';
import { Button } from '~/landing/components/shared';

type Props = {
  goToDemo: () => void;
};

export const MobileMenu = ({ goToDemo }: Props) => {
  const t = useTranslations('landing.germen.simulator.header');
  const [open, setOpen] = useState(false);

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setOpen(false);

    // Wait for sheet to close and scroll lock to be removed
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        const headerHeight = 80; // Approximate header height
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 350);
  };

  const handleSimulatorClick = () => {
    goToDemo();
    setOpen(false);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button isIcon variant="outline">
          <Icon className="size-5" name="menu" />
          <span className="sr-only">{t('openMenu')}</span>
        </Button>
      </SheetTrigger>
      <SheetContent className="flex w-screen flex-col" side="right">
        <div className="border-b pb-4">
          <Image
            alt="Germen logo icon"
            height={24}
            src={images.germen['logo-icon']}
            width={24}
          />
        </div>
        <nav className="flex flex-1 items-center justify-center">
          <ul className="flex flex-col gap-6 text-center">
            <li>
              <button
                className="text-2xl font-medium hover:underline"
                onClick={handleSimulatorClick}
              >
                {t('navigation.simulator')}
              </button>
            </li>
            <li>
              <a
                className="text-2xl font-medium hover:underline"
                href="#contact"
                onClick={handleLinkClick}
              >
                {t('navigation.contact')}
              </a>
            </li>
          </ul>
        </nav>
      </SheetContent>
    </Sheet>
  );
};
